(function () {
  var COOKIE_NAME = '_pandectes_gdpr';
  var DEFAULT_MASK = 7;
  var CATEGORY_BITS = [1, 2, 4];

  function getCookie(name) {
    var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? match[1] : null;
  }

  function readConsentState() {
    var rawValue = getCookie(COOKIE_NAME);
    if (!rawValue) return null;

    try {
      var decoded = window.atob(decodeURIComponent(rawValue));
      var parsed = JSON.parse(decoded);
      return typeof parsed.preferences === 'number' ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function writeConsentState(mask) {
    var payload = window.btoa(
      JSON.stringify({
        preferences: mask,
        consentedAt: new Date().toISOString(),
      })
    );

    var parts = [
      COOKIE_NAME + '=' + encodeURIComponent(payload),
      'path=/',
      'max-age=31536000',
      'samesite=lax',
    ];

    if (window.location.protocol === 'https:') {
      parts.push('secure');
    }

    document.cookie = parts.join('; ');
  }

  function getAllowedConsent(mask) {
    return {
      preferences: !(mask & 1),
      analytics: !(mask & 2),
      marketing: !(mask & 4),
    };
  }

  function withTrackingConsentApi(callback) {
    if (!window.Shopify) return;

    if (window.Shopify.trackingConsent || window.Shopify.customerPrivacy) {
      callback();
      return;
    }

    if (!window.Shopify.loadFeatures) return;

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) callback();
    });
  }

  function syncShopifyConsent(mask) {
    withTrackingConsentApi(function () {
      var api = window.Shopify && (window.Shopify.trackingConsent || window.Shopify.customerPrivacy);
      if (!api || typeof api.setTrackingConsent !== 'function') return;

      api.setTrackingConsent(getAllowedConsent(mask), function () {});
    });
  }

  function unblockCategory(category) {
    var rules = window.PandectesRules;
    var patterns =
      window.PandectesSettings &&
      window.PandectesSettings.blocker &&
      window.PandectesSettings.blocker.patterns &&
      window.PandectesSettings.blocker.patterns.blackList &&
      window.PandectesSettings.blocker.patterns.blackList[category];

    if (!rules) return;

    if (Array.isArray(patterns) && patterns.length > 0 && typeof rules.unblock === 'function') {
      rules.unblock(patterns);
    }

    if (typeof rules.unblockCss === 'function') rules.unblockCss(category);
    if (typeof rules.unblockIFrames === 'function') rules.unblockIFrames(category);
    if (typeof rules.unblockBeacons === 'function') rules.unblockBeacons(category);
    if (typeof rules.unblockInlineScripts === 'function') rules.unblockInlineScripts(category);
    if (typeof rules.unblockInlineCss === 'function') rules.unblockInlineCss(category);
  }

  function dispatchConsentEvent(mask) {
    window.dispatchEvent(
      new CustomEvent('PandectesEvent_OnConsent', {
        detail: { preferences: mask },
      })
    );

    document.dispatchEvent(
      new CustomEvent('PandectesEvent_OnConsent', {
        detail: { preferences: mask },
      })
    );
  }

  function persistConsent(mask) {
    writeConsentState(mask);
    syncShopifyConsent(mask);
    dispatchConsentEvent(mask);
  }

  function unblockAllowedCategories(mask) {
    CATEGORY_BITS.forEach(function (category) {
      if (!(mask & category)) {
        try {
          unblockCategory(category);
        } catch (error) {
          console.error('Cookie consent unblock failed for category', category, error);
        }
      }
    });
  }

  function applyConsent(mask) {
    persistConsent(mask);

    window.setTimeout(function () {
      unblockAllowedCategories(mask);
    }, 0);
  }

  function waitForAnimationEnd(element) {
    return new Promise(function (resolve) {
      var hasResolved = false;

      function finish() {
        if (hasResolved) return;
        hasResolved = true;
        element.removeEventListener('animationend', finish);
        resolve();
      }

      element.addEventListener('animationend', finish, { once: true });
      window.setTimeout(finish, 350);
    });
  }

  function createController(root) {
    var dialog = root.querySelector('[data-cookie-consent-dialog]');
    var closeButtons = root.querySelectorAll('[data-cookie-consent-close]');
    var openSettingsButton = root.querySelector('[data-cookie-consent-open-settings]');
    var saveButton = root.querySelector('[data-cookie-consent-save]');
    var denyButtons = root.querySelectorAll('[data-cookie-consent-deny]');
    var acceptButtons = root.querySelectorAll('[data-cookie-consent-accept]');
    var introView = root.querySelector('[data-cookie-consent-view="intro"]');
    var preferencesView = root.querySelector('[data-cookie-consent-view="preferences"]');
    var toggles = root.querySelectorAll('[data-cookie-consent-toggle]');
    var previousScrollY = 0;

    function setView(view) {
      root.dataset.view = view;
      introView.hidden = view !== 'intro';
      preferencesView.hidden = view !== 'preferences';
    }

    function setToggleState(mask) {
      toggles.forEach(function (toggle) {
        var bit = Number(toggle.dataset.categoryBit);
        toggle.checked = !(mask & bit);
      });
    }

    function getMaskFromToggles() {
      return Array.prototype.reduce.call(
        toggles,
        function (mask, toggle) {
          var bit = Number(toggle.dataset.categoryBit);
          return toggle.checked ? mask : mask | bit;
        },
        0
      );
    }

    function lockScroll() {
      previousScrollY = window.scrollY;
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + previousScrollY + 'px';
    }

    function unlockScroll() {
      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo({ top: previousScrollY, behavior: 'instant' });
    }

    function open(mask) {
      setToggleState(typeof mask === 'number' ? mask : DEFAULT_MASK);
      setView('intro');
      root.hidden = false;
      lockScroll();

      if (!dialog.open) {
        dialog.showModal();
      }
    }

    async function close() {
      if (!dialog.open) {
        root.hidden = true;
        return;
      }

      dialog.classList.add('dialog-closing');
      await waitForAnimationEnd(dialog);
      dialog.close();
      dialog.classList.remove('dialog-closing');
      root.hidden = true;
      unlockScroll();
    }

    function save(mask) {
      applyConsent(mask);
      close();
    }

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (root.dataset.view === 'preferences') {
          setView('intro');
          return;
        }

        save(DEFAULT_MASK);
      });
    });

    if (openSettingsButton) {
      openSettingsButton.addEventListener('click', function () {
        setView('preferences');
      });
    }

    if (saveButton) {
      saveButton.addEventListener('click', function () {
        save(getMaskFromToggles());
      });
    }

    denyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        save(DEFAULT_MASK);
      });
    });

    acceptButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        save(0);
      });
    });

    return {
      open: open,
      close: close,
      showIfNeeded: function () {
        var currentState = readConsentState();
        if (!currentState) {
          open(DEFAULT_MASK);
        }
      },
      reset: function () {
        document.cookie = COOKIE_NAME + '=; path=/; max-age=0; samesite=lax';
        open(DEFAULT_MASK);
      },
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-cookie-consent]');
    if (!root) return;

    var controller = createController(root);
    window.FaynCookieConsent = controller;

    document.querySelectorAll('[href*="#reopenBanner"]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        var currentState;

        event.preventDefault();
        currentState = readConsentState();
        controller.open(currentState ? currentState.preferences : DEFAULT_MASK);
      });
    });

    controller.showIfNeeded();
  });
})();
